/* eslint-disable import/first */
import React from 'react';

export default function Skip(props) {
  return (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.3287 11.4998L10.585 6.75605L11.94 5.40097L18.0389 11.4998L11.94 17.5986L10.585 16.2435L15.3287 11.4998Z"
        fill="black"
      />
      <path
        d="M9.91758 11.4998L5.17383 6.75605L6.52891 5.40097L12.6277 11.4998L6.52891 17.5986L5.17383 16.2435L9.91758 11.4998Z"
        fill="black"
      />
    </svg>
  );
}
